// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Constants for the whole UI
*/
/*
Constants for headers
*/
.btn {
  letter-spacing: 0.16em;
  padding: 0.6em 1em;
  font-weight: 700;
  min-height: 48px;
  font-size: 1em;
}
.btn.btn-primary {
  color: white;
  background: #dc2a4d;
  border-color: #dc2a4d;
}
.btn.btn-primary:focus {
  background: #dc2a4d;
  border-color: #dc2a4d;
}
.btn.btn-primary:active, .btn.btn-primary:active:focus, .btn.btn-primary:active:hover, .btn.btn-primary:hover, .btn.btn-primary:not(:disabled):not(.disabled):active {
  background: #8c1b32;
  border-color: #8c1b32;
}
.btn.btn-primary:disabled, .btn.btn-primary:disabled:hover {
  background: #dc2a4d;
  border-color: #dc2a4d;
  opacity: 0.5;
}
.btn.btn-secondary {
  color: #fff;
  background: #38A121;
  border-color: #38A121;
}
.btn.btn-secondary:focus {
  background: #38A121;
  border-color: #38A121;
}
.btn.btn-secondary:active, .btn.btn-secondary:active:focus, .btn.btn-secondary:active:hover, .btn.btn-secondary:hover, .btn.btn-secondary:not(:disabled):not(.disabled):active {
  background: #38A121;
  border-color: #38A121;
}
.btn.btn-secondary:disabled, .btn.btn-secondary:disabled:hover {
  background: #38A121;
  border-color: #38A121;
  opacity: 0.5;
}
.btn.btn-default {
  color: #000;
  background: #dddddd;
  border-color: #dddddd;
}
.btn.btn-default:focus {
  background: #dddddd;
  border-color: #dddddd;
}
.btn.btn-default:active, .btn.btn-default:active:focus, .btn.btn-default:active:hover, .btn.btn-default:hover, .btn.btn-default:not(:disabled):not(.disabled):active {
  background: #757575;
  border-color: #757575;
}
.btn.btn-default:disabled, .btn.btn-default:disabled:hover {
  background: #dddddd;
  border-color: #dddddd;
  opacity: 0.5;
}

/*
Constants for the whole UI
*/
/*
Constants for headers
*/
h1, .h1,
h2, .h2,
h3, .h3,
h4, .h4,
h5, .h5,
h6, .h6 {
  font-weight: 200;
}

h1, .h1 {
  font-size: 2em;
  letter-spacing: -0.1em;
}

h2, .h2 {
  font-size: 1.5em;
}

h3, .h3 {
  font-size: 1.3em;
}

h4, .h4 {
  font-size: 1.2em;
}

h5, .h5 {
  font-size: 1.1em;
}

h6, .h6 {
  font-size: 1em;
}

.background-img {
  position: absolute;
  width: 100%;
  overflow: hidden;
}
.background-img picture {
  max-height: 50%;
  height: 50%;
  width: 100%;
}
.background-img picture img {
  width: 100%;
}
.background-img:after {
  content: "";
  display: block;
  width: 110%;
  height: 30%;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  transform: rotate(-3.6deg);
  transform-origin: left top;
}

:root {
  --green-button: #38A121;
  --green: #2B8F14;
  --color-input-text: #44474B;
}

.green-text {
  color: #2B8F14;
  font-weight: 400;
}

a.green-text-strong {
  cursor: pointer;
  color: #2B8F14;
  font-weight: 600;
  text-decoration: none;
}

.gray-text {
  color: #44474B;
  font-weight: bold;
}

@font-face {
  font-family: "PFBeauSansPro";
  src: url("https://static.fif.tech/omnichannel-assets/bfpe/fonts/pfbeausanspro-light-webfont.woff");
  font-weight: normal;
}
@font-face {
  font-family: "PFBeauSansPro";
  src: url("https://static.fif.tech/omnichannel-assets/bfpe/fonts/pfbeausanspro-bold-webfont.woff2");
  font-weight: bold;
}
@font-face {
  font-family: "fb-thin";
  font-style: normal;
  font-weight: 200;
  src: url("https://static-test.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/fonts/pfbeausansprothinwebfont.eot");
  src: url("https://static-test.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/fonts/pfbeausansprothinwebfont.eot?#iefix") format("embedded-opentype"), url("https://static-test.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/fonts/pfbeausansprothinwebfont.woff2") format("woff2"), url('pfbeausansprothinwebfont.7d29445011e2149e.woff') format("woff"), url("https://static-test.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/fonts/pfbeausansprothinwebfont.ttf") format("truetype"), url("https://static-test.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/fonts/pfbeausansprothinwebfont.svg#pf_beausans_probold") format("svg");
}
input[type=date]::-webkit-calendar-picker-indicator {
  color: rgba(0, 0, 0, 0);
  opacity: 1;
  display: block;
  background: url("https://static-qa.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/icons/generic/calendar.svg") no-repeat;
  width: 20px;
  height: 20px;
  border-width: thin;
}

.form-group-button button {
  font-weight: unset;
}

a.green-text {
  cursor: pointer;
  font-weight: 400;
  text-decoration: none;
}

a:hover {
  color: #2B8F14 !important;
  text-decoration: none !important;
}

.phone-code-number-container {
  margin: 0.2em 0 0.2em 0;
}

.custom-checkbox {
  margin: 0 0 2em 1.4em;
}
.custom-checkbox label {
  font-size: 14px;
}
.custom-checkbox input[type=checkbox] + label {
  display: block;
  margin: 0.2em;
  cursor: pointer;
  padding: 0.2em;
}
.custom-checkbox input[type=checkbox] {
  display: none;
}
.custom-checkbox input[type=checkbox] + label:before {
  content: "✔";
  border: 1px solid #C9D4DF;
  zoom: 0.7;
  border-radius: 6px;
  display: inline-block;
  width: 2em;
  height: 2em;
  padding-left: 0.5em;
  padding-top: 0.25em;
  margin: 0 0.5em 3px -2.5em;
  vertical-align: bottom;
  color: transparent;
  transition: 0.2s;
}
.custom-checkbox input[type=checkbox]:checked + label:before {
  background-color: #38A121;
  border-color: MediumSeaGreen;
  color: #fff;
}
.custom-checkbox input[type=checkbox]:checked + label:before.right {
  left: auto;
  right: 0;
  position: absolute;
}

.custom-checkbox-right {
  margin-bottom: 2em;
}
.custom-checkbox-right input[type=checkbox] + label {
  display: block;
  margin: 0.5em 0 0 -0.2em;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  font-family: "fb-thin", sans-serif;
  padding-right: 20px;
}
.custom-checkbox-right input[type=checkbox] {
  display: none;
}
.custom-checkbox-right input[type=checkbox] + label:before {
  content: "✔";
  left: auto;
  right: 0;
  border: 1px solid #C9D4DF;
  position: absolute;
  display: inline-block;
  vertical-align: bottom;
  color: transparent;
  transition: 0.2s;
  border-radius: 17px;
  height: 1.9em;
  width: 1.9em;
  padding: 4px 6px;
  margin: 0;
  zoom: 0.8;
}
.custom-checkbox-right input[type=checkbox]:checked + label:before {
  background-color: #38A121;
  border-color: MediumSeaGreen;
  color: #fff;
  left: auto;
  right: 0;
  position: absolute;
}

.control-validate.ng-touched.ng-valid {
  border-color: #2B8F14;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.control-validate.ng-touched.ng-valid:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.control-validate.ng-touched.ng-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.control-validate.ng-touched.ng-invalid:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.control-validate.ng-touched.ng-invalid + .invalid-feedback {
  display: block;
}

.modal-content {
  overflow-y: hidden !important;
  overflow-x: hidden;
}

.principal-title {
  font-family: "fb-thin", sans-serif;
  letter-spacing: -0.02em;
  font-weight: unset;
  font-size: 28px;
  color: #44474B;
}

.principal-title-green {
  color: #2B8F14;
}

.text-footer {
  text-align: justify;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: -0.2625px;
  color: #63696E;
  flex: none;
  order: 5;
  align-self: center;
}

label {
  color: #44474B;
  display: inline-block;
  margin-bottom: 0.5rem;
}

.form-control {
  color: #44474B;
  font-size: 1rem;
  padding: 0.75rem;
  height: initial;
}
.form-control:focus {
  border-color: #2B8F14;
}

.form-control.is-valid {
  border-color: #28a745;
}

.form-group {
  min-height: 6.4rem;
}

form {
  max-height: 100%;
  overflow: hidden;
  position: relative;
  padding-bottom: 4rem;
}

.form-group-button {
  margin-top: 15px;
  min-height: 3rem;
  padding: 16px 0px;
  background-color: #ffffff;
}
.form-group-button.full-width {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0px;
  padding: 16px 16px;
}
.form-group-button button {
  width: 100%;
  border-radius: 25px;
  border-color: #38A121;
}

/*******************************
STYLES CONTAINER
*******************************/
.form-group label:first-child {
  margin-top: 1em;
}
.form-group .form-control {
  color: #44474B;
  font-size: 1rem;
  padding: 0.75rem;
  height: initial;
  margin: 0.2em 0 0.2em 0;
}
.form-group select.form-control:not([size]):not([multiple]) {
  height: calc(2.25rem + 10px);
  margin: 0.2em 0 0.2em 0;
}
.form-group select.custom {
  background-image: url("https://static.fif.tech/onboarding-peru-cuentas-assets/accounts/assets/icons/generic/custom-select-icon.svg");
  background-repeat: no-repeat;
  background-position: right 10px center;
  appearance: none;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: 1px;
  margin-left: calc(var(--bs-gutter-x) / -2);
}

.row_custom {
  display: flex;
  flex-wrap: wrap;
}

.row_container-form-mobile {
  position: relative;
}

.div-image-wrapper {
  padding: 0;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 578.98px) {
  .container-form {
    margin-left: 5%;
    margin-right: 5%;
    text-align: left;
  }
}
/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .container-form {
    margin-left: 10%;
    margin-right: 10%;
    text-align: left;
  }
}
/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .container-form {
    margin-left: 15%;
    margin-right: 15%;
    text-align: left;
  }
}
/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .container-form {
    margin-left: 20%;
    margin-right: 20%;
    text-align: left;
  }
}
/*******************************
STYLES CUSTOMS ROWS FOR MOBILE
*******************************/
/* Small devices (landscape phones, 767.98 and down) */
@media (max-width: 767.98px) {
  .row_container-form-mobile {
    background: #FFF;
    margin-left: 5px;
    margin-right: 5px;
    padding-left: 10px;
    padding-right: 10px;
    box-shadow: 0px 1px 1px rgba(0, 51, 102, 0.05), 0px 4px 12px rgba(0, 51, 102, 0.08);
  }
}
/*******************************
STYLES FORM
*******************************/
.btn-success:hover, .btn-success:focus, .btn-success:disabled, .btn-success:active, .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  background: #00943E;
  border: #00943E;
  color: white;
}

.position-content-center {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.margin-top-text {
  margin-top: 30px;
}

.margin-bottom-text {
  margin-bottom: 30px;
}

.text-tariff {
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  color: #007A33;
  flex: none;
  order: 0;
  align-self: center;
  margin: 4px 0px;
}

.sub-title-gray-finish-config {
  background: #F2F5F7;
  border-radius: 6px;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: -0.4px;
  color: #5C6166;
  margin-top: 20px;
  padding: 5px;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
}

.sub-title-gray-footer-finish-config {
  background: #F2F5F7;
  border-radius: 6px;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: -0.4px;
  color: #5C6166;
  margin-top: 20px;
  padding: 15px;
  width: 100%;
  text-align: justify;
}

/* Small devices (landscape phones, 767.98 and down) */
@media (max-width: 767.98px) {
  .sub-title-gray {
    font-size: 16px;
    line-height: 29px;
    letter-spacing: -0.364865px;
    color: #5C6166;
    margin-top: 20px;
    margin-bottom: -10px;
  }
  .sub-title-green-underline {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.2625px;
    text-decoration-line: underline;
    color: #4D833F;
    margin-top: 30px;
    cursor: pointer;
  }
  .sub-title-gray-custom {
    font-size: 16px;
    line-height: 29px;
    letter-spacing: -0.364865px;
    color: #5C6166;
    margin-top: 20px;
    margin-bottom: -10px;
    padding-right: 20px;
  }
  .input-text-basic {
    background: #FFFFFF;
    border: 0.608108px solid #B8C2CC;
    box-sizing: border-box;
    border-radius: 7.2973px;
    width: 100%;
    height: 58px;
    padding-left: 10px;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: -0.243243px;
    color: #8A9199;
    margin-top: 5px;
  }
  .input-select-basic {
    background: #fff;
    border: 1.21622px solid #cfdae6;
    box-sizing: border-box;
    border-radius: 7.2973px;
    width: 100%;
    height: 58px;
    padding-left: 10px;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: -0.243243px;
    color: #5C6166;
    margin-top: 5px;
    text-transform: capitalize;
  }
  .input-group .input-group-text {
    background: #F4F7F8;
    border-radius: 6px 0px 0px 6px;
    height: 50px;
  }
  .input-group .input-text-basic {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
  }
  .principal-title-gray {
    font-weight: bold;
    font-size: 24px;
    line-height: 125%;
    letter-spacing: -0.01em;
    color: #5C6166;
    flex: auto;
    text-align: center;
    order: 0;
    align-self: flex-start;
    margin-bottom: 10px;
    margin-top: 30px;
  }
  .principal-title-gray-center {
    font-weight: bold;
    font-size: 24px;
    line-height: 125%;
    letter-spacing: -0.01em;
    color: #5C6166;
    flex: auto;
    text-align: center;
    order: 0;
    align-self: flex-start;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .principal-title-gray-center-finish-config {
    font-weight: bold;
    font-size: 16px;
    line-height: 125%;
    letter-spacing: -0.01em;
    color: #5C6166;
    flex: none;
    order: 0;
    align-self: flex-start;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .principal-title-gray_modal {
    font-weight: bold;
    font-size: 24px;
    line-height: 125%;
    letter-spacing: -0.01em;
    color: #5C6166;
    flex: none;
    order: 0;
    align-self: flex-start;
    margin-bottom: 30px;
    margin-top: 30px;
    text-align: center;
  }
  .principal-title-gray-no-offer {
    font-weight: bold;
    font-size: 24px;
    line-height: 125%;
    letter-spacing: -0.01em;
    color: #5C6166;
    flex: none;
    order: 0;
    align-self: flex-start;
    margin-bottom: 30px;
    margin-top: 30px;
    text-align: center;
  }
  .principal-title-green-finish-config {
    clear: both;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.2625px;
    color: #007A33;
  }
  .text-no-offer {
    font-size: 15px;
    line-height: 175%;
    letter-spacing: -0.2px;
    color: #5C6166;
    text-align: center;
  }
  .text-info-gray {
    font-size: 15px;
    line-height: 26px;
    /* or 175% */
    text-align: center;
    letter-spacing: -0.291146px;
    color: #5C6166;
  }
}
/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .sub-title-gray {
    font-size: 16px;
    line-height: 29px;
    letter-spacing: -0.364865px;
    color: #5C6166;
    margin-top: 20px;
    margin-bottom: -10px;
  }
  .sub-title-green-underline {
    font-size: 19px;
    line-height: 24px;
    letter-spacing: -0.2625px;
    text-decoration-line: underline;
    color: #4D833F;
    margin-top: 30px;
    cursor: pointer;
  }
  .input-text-basic {
    background: #FFFFFF;
    border: 0.608108px solid #B8C2CC;
    box-sizing: border-box;
    border-radius: 7.2973px;
    width: 100%;
    height: 58px;
    padding-left: 10px;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: -0.243243px;
    color: #8A9199;
    margin-top: 5px;
  }
  .input-select-basic {
    background: #fff;
    border: 1.21622px solid #cfdae6;
    box-sizing: border-box;
    border-radius: 7.2973px;
    width: 100%;
    height: 58px;
    padding-left: 10px;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: -0.243243px;
    color: #5C6166;
    margin-top: 5px;
    text-transform: capitalize;
  }
  .input-group .input-group-text {
    background: #F4F7F8;
    border-radius: 6px 0px 0px 6px;
    height: 50px;
    border-right-color: transparent;
  }
  .input-group .input-text-basic {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    border-radius: 6px 0px 0px 6px;
    border-left-color: transparent;
  }
  .principal-title-gray {
    font-weight: bold;
    font-size: 24px;
    line-height: 125%;
    letter-spacing: -0.01em;
    color: #5C6166;
    flex: auto;
    text-align: center;
    order: 0;
    align-self: flex-start;
    margin-bottom: 10px;
    margin-top: 30px;
  }
  .principal-title-gray-center {
    font-weight: bold;
    font-size: 24px;
    line-height: 125%;
    letter-spacing: -0.01em;
    color: #5C6166;
    flex: none;
    order: 0;
    align-self: flex-start;
    margin-bottom: 30px;
    margin-top: 30px;
    text-align: center;
  }
  .principal-title-gray-center-finish-config {
    font-weight: bold;
    font-size: 16px;
    line-height: 125%;
    letter-spacing: -0.01em;
    color: #5C6166;
    flex: none;
    order: 0;
    align-self: flex-start;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .principal-title-gray-no-offer {
    font-weight: bold;
    font-size: 36px;
    line-height: 125%;
    letter-spacing: -0.01em;
    color: #5C6166;
    flex: none;
    order: 0;
    align-self: flex-start;
    margin-bottom: 30px;
    margin-top: 30px;
    text-align: center;
  }
  .principal-title-green-finish-config {
    clear: both;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.2625px;
    color: #007A33;
  }
  .text-no-offer {
    font-size: 19px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.3px;
    color: #5C6166;
  }
  .progress-dot-margin {
    margin-bottom: 30px;
  }
}
/*******************************
STYLES CHECK ROUND
*******************************/
/* The switch - the box around the slider */
.switch {
  position: relative;
  width: 48px;
  height: 28px;
  float: right;
  margin-top: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider-container {
  display: flex;
  justify-content: flex-end;
  margin: 0 0 1em;
}
.slider-container .slider-label {
  margin-right: 1em;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #EAEFF4;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}

input.success:checked + .slider {
  background-color: #38A121;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
  box-shadow: 0px 1px 1px rgba(0, 51, 102, 0.05), 0px 6px 12px -3px rgba(0, 51, 102, 0.075);
}

/*******************************
STYLES BUTTONS
*******************************/
.btn.btn-block.btn-secondary {
  letter-spacing: 1px;
}

.btn-div-fix-footer {
  display: block;
  margin-top: -95px;
  text-align: center;
}
.btn-div-fix-footer .btn {
  max-width: 465px;
}

.btn-div-form {
  display: none;
}

.not-client-info3Continue-container {
  margin-top: 30px;
}

.btn-next-large-generic {
  width: 100%;
  background: #00943E;
  color: white;
  height: 50px;
  border-radius: 7.21622px;
  flex: none;
  order: 3;
  align-self: center;
  margin-top: 30px;
  margin-bottom: 30px;
}

/* Small devices (landscape phones, 767.98 and down) */
@media (max-width: 767.98px) {
  .btn-div-form {
    display: block;
  }
  .btn-div-fix-footer {
    display: none;
  }
  .btn-next-large {
    width: 100%;
    background: #00943E;
    color: white;
    height: 50px;
    border-radius: 7.21622px;
    flex: none;
    order: 3;
    align-self: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .btn-next-large-joint-account {
    width: 100%;
    background: #00943E;
    color: white;
    height: 50px;
    border-radius: 7.21622px;
    flex: none;
    order: 3;
    align-self: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .btn-round {
    border-radius: 50%;
    width: 65px;
    padding: 15px;
    float: right;
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .btn-next-large {
    width: 100%;
    background: #00943E;
    color: white;
    height: 50px;
    border-radius: 7.21622px;
    flex: none;
    order: 3;
    align-self: center;
  }
  .btn-next-large-joint-account {
    width: 100%;
    background: #00943E;
    color: white;
    height: 50px;
    border-radius: 7.21622px;
    flex: none;
    order: 3;
    align-self: center;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .btn-round {
    border-radius: 50%;
    width: 65px;
    padding: 15px;
    float: right;
    margin-top: -100px;
  }
}
.btn-next-large-fix-footer {
  width: 100%;
  background: #00943E;
  height: 50px;
  border-radius: 7.21622px;
  flex: none;
  order: 3;
  align-self: center;
  margin-top: 30px;
  margin-bottom: 30px;
}

/*******************************
STYLES JOINT
*******************************/
.alert-joint-tittle {
  background: #EDF7EB;
  border-radius: 6px;
  align-self: stretch;
}

.label-joint-tittle {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 20px;
}

/*******************************
STYLES tooltip client
*******************************/
.tooltip-client {
  position: absolute;
  border-bottom: 1px dotted black;
  width: 400px;
  padding-left: 45px;
  left: 0;
  top: 25px;
}

.tooltip-text-client {
  text-align: justify;
  position: relative;
  z-index: 1;
  bottom: 125%;
  transition: opacity 0.3s;
  color: #5C6166;
  background: #FFFFFF;
  border-radius: 6px;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.2px;
  padding: 20px;
  box-shadow: 2px 2px 5px #999;
}

/*******************************
STYLES CHECKS
*******************************/
.input-check-basic {
  border: 1.28716px solid #B8C2CC;
  box-sizing: border-box;
  border-radius: 7.72297px;
  margin-top: 5px;
  margin-right: 15px;
}

.input-text-check-gray {
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.33788px;
  color: #5C6166;
}

.input-text-check-green {
  font-size: 16px;
  line-height: 25px;
  letter-spacing: -0.33788px;
  color: #007A33;
  text-decoration: underline;
}

.checkboxContent {
  display: inline-flex;
}

.executive-alert {
  padding: 20px 20px 20px 0px;
}
.executive-alert span {
  font-weight: bold;
}

/*******************************
BTN LG XL SIZES
*******************************/
.btn-continue-lg, .btn-continue-xl {
  display: none;
}

@media screen and (max-width: 1499px) {
  .btn-continue-lg {
    display: flex;
  }
}
@media screen and (min-width: 1500px) {
  .btn-continue-xl {
    display: flex;
  }
}
.joint-account-wrapper {
  padding: 16px;
  border-radius: 6px;
  background: #F4F7F8;
}

.container-questions label.label-obligatorio {
  align-self: auto !important;
  bottom: initial !important;
}

.card-header .arrowDown {
  top: 17px;
}

.container-pep.compact > .container-questions .card .btn-link {
  text-decoration: none;
}
.container-pep.compact > .container-questions .card .btn-link:focus {
  box-shadow: none;
}

.information-container {
  background-color: #F3F5FC;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin: 20px 0;
  color: #333537;
}
.information-container .information-icon-container {
  margin: auto 10px;
  float: left;
}
.information-container .information-content {
  margin: 10px;
}

.wc-container .wc-container-in .principal-title, .wc-container .wc-container-in .form-group {
  text-align: left;
}
.wc-container .wc-container-in .green-text {
  color: #2B8F14;
  font-weight: bold;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
